import { Center, Spinner } from '@frontend/legacy-components';

export const SpinnerOverlay = () => {
  return (
    <Center
      position="absolute"
      zIndex="overlay"
      top={0}
      left={0}
      width="100%"
      height="100%"
      opacity={0.9}
      backgroundColor="page.surface"
    >
      <Spinner size="lg" />
    </Center>
  );
};
